export const GET_ALL_EVENT_GROUPS = "GET_ALL_EVENT_GROUPS";
export const GET_ALL_EVENT_GROUPS_SUCCESS = "GET_ALL_EVENT_GROUPS_SUCCESS";
export const GET_ALL_EVENT_GROUPS_FAILURE = "GET_ALL_EVENT_GROUPS_FAILURE";
